module.exports = __webpack_public_path__ + "media/img/event/speakers/Chef-Andy-4d6c2e28e620cc6b006ff7676c056bf7.jpg";